import { Button } from '@/components/Button/Button'
import { centsToDollars } from '@/helpers/currency.helper'
import Big from 'big.js'
import moment from 'moment'
import React, { useState } from 'react'
import { ReactComponent as VisaIcon } from '@/assets/img/card/visa-medium.svg'
// eslint-disable-next-line
import { ReactComponent as DinersIcon } from '@/assets/img/card/diners-medium.svg'
// eslint-disable-next-line
import { ReactComponent as MastercardIcon } from '@/assets/img/card/mastercard-medium.svg'
// eslint-disable-next-line
import { ReactComponent as AmexIcon } from '@/assets/img/card/amex-medium.svg'
import { ReactComponent as WarningIcon } from '@/assets/icons/warning-heroicon.svg'

import './SettingsAreaBilling.scoped.sass'
import sessionService from '@/app-domains/user/session/session.service'
import billingService from '@/app-domains/user/billing/billing.service'
import modalService from '@/services/modal.service'
import { CancelSubscriptionModal } from './components/CancelSubscriptionModal/CancelSubscriptionModal'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import { CancelTrialModal } from './components/CancelTrialModal/CancelTrialModal'
import { UpgradeSubscriptionModal } from './components/UpgradeSubscriptionModal/UpgradeSubscriptionModal'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import { ReactivateSubscriptionModal } from './components/ReactivateSubscriptionModal/ReactivateSubscriptionModal'
export function SettingsAreaBilling () {
  // eslint-disable-next-line
  const [customerBillingData, setCustomerBillingData] = useState(sessionService.getMe().me.billing)
  const [onboardingData] = useState(sessionService.getMe().me.onboarding)

  function getFormattedSubscriptionPrice () {
    return centsToDollars(Big(customerBillingData.subscription.price).div(100).round(2).toNumber())
  }

  function getFormattedExpirationDate () {
    let { expirationMonth, expirationYear } = customerBillingData.paymentMethods[0]
    expirationMonth = expirationMonth.toString().length === 1 ? `0${expirationMonth.toString()}` : expirationMonth.toString()
    return `${expirationMonth}/${expirationYear}`
  }

  function getCardDetailTitle () {
    let brand = customerBillingData.paymentMethods[0].brand
    brand = `${brand[0].toUpperCase()}${brand.slice(1)}`
    return `${brand} ending in ${customerBillingData.paymentMethods[0].lastFourDigits}`
  }

  async function cancelSubscription () {
    openCancelSubscriptionModal()
    /*
    await billingService.cancelSubscription()
    await sessionService.setMeInfo()
    */
  }

  async function reactivateSubscription () {
    await billingService.reactivateSubscription()
    await sessionService.setMeInfo()
  }

  async function upgradeSubscription () {
    modalService.open(<UpgradeSubscriptionModal/>)

    // await billingService.reactivateSubscription()
    // await sessionService.setMeInfo()
  }

  function openCancelSubscriptionModal () {
    modalService.open(<CancelSubscriptionModal/>)
  }

  function openCancelTrialModal () {
    modalService.open(<CancelTrialModal/>)
  }

  useRenderEvent(['SUBSCRIPTION:CHANGED'])

  useRenderEvent(['REACTIVATE_SUBSCRIPTION_MODAL:SHOW'], () => {
    modalService.open(<ReactivateSubscriptionModal/>)
  })

  return (
    <div className="settings-general">
      { customerBillingData && <><div className="group">
        <div className="title">
          {sessionService.getMe().me.fullname}
        </div>
        <div className="group-content payment-methods">
          <div className="card-logo">
            { customerBillingData.paymentMethods[0].brand === 'visa' && <VisaIcon/>}
            { customerBillingData.paymentMethods[0].brand === 'mastercard' && <MastercardIcon/>}
            { customerBillingData.paymentMethods[0].brand === 'amex' && <AmexIcon/>}
            { customerBillingData.paymentMethods[0].brand === 'diners' && <DinersIcon/>}
          </div>
          <div className="card-detail">
            <div className="card-detail-title">
              {getCardDetailTitle()}
            </div>
            <div className="card-detail-subtitle">
              Card expires at {getFormattedExpirationDate()}
            </div>
          </div>
        </div>
      </div>
        <div className="group subscription-details">
          <div className="title">
            Next invoice on {moment.unix(customerBillingData.subscription.periodEnd).format('MMM DD, YYYY')}
          </div>
          <div className="group-content">
            <section>
              <div className='section-content'>
                <div className='content-left'>
                  <div className='content-left-title'>Pro subscription</div>
                  <div className='content-left-main'>
                    <span className='price-amount'>{getFormattedSubscriptionPrice()}</span>
                    /
                    <span className='price-period'>month</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="group">
          <div className="title">
            Billing History
          </div>
          <div className="group-content">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {customerBillingData.invoices.map((invoice) => (<tr key={invoice.createdDate}>
                  <td>{moment.unix(invoice.createdDate).format('MMM DD, YYYY')}</td>
                  <td>Subscription</td>
                  <td>{centsToDollars(invoice.totalAmount / 100)}</td>
                  <td><a target='_blank' href={invoice.invoicePdf} rel="noreferrer">PDF</a></td>
                </tr>))
              }
              </tbody>
            </table>
          </div>
        </div>
      </> }
      
      <div className="group">
        <div className="title">
          Account Management
        </div>
        { sessionService.getMe().me.status === 'trial_active' &&
        <div className="group-content mb-l">
          <SimpleBanner type='warning'>
            <span className='flex items-center font-medium'><WarningIcon style={{ display: 'inline-block', marginRight: '6px' }}/>
              <b className='mr-xs'>IMPORTANT:</b> Your trial will expire in {onboardingData.trialRemainingDays} days</span>
            <span>
              That means, after the trial expires, you won't be able to continue using any feature of this service
              until you upgrade your subscription.
            </span>
            <br/>
          </SimpleBanner>
        </div>}
        
        <div className="group-content-bottom">
          { (sessionService.getMe().me.status === 'trial_active' || sessionService.getMe().me.status === 'trial_cancelled') && <div className='billing-button'><Button type='primary' content='Upgrade my subscription' click={upgradeSubscription} /></div>}
          { sessionService.getMe().me.status === 'trial_active' && <div className='billing-button'><Button type='secondary' content='Cancel Trial' click={openCancelTrialModal} /></div>}
          { sessionService.getMe().me.status === 'active' && <div className='billing-button'><Button type='secondary' content='Cancel Subscription' click={cancelSubscription} /></div>}
          { sessionService.getMe().me.status === 'subscription-cancel' && <div className='billing-button'><Button type='primary' content='Reactivate Subscription' click={reactivateSubscription} /></div>}
        </div>
      </div>

    </div>
  )
}
